import {
  MUTATION_REQUEST_SENT,
  MUTATION_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';
import { RADAR_CREATE_SESSIONS } from '@web-platform/shared-universal-types/src/network/requestTypes';
import {
  getPlacesResponseBody,
  isPlacesResponseError,
} from '@web-platform/shared-universal-utils-frontend/src/helpers/radarPlacesResponse';

import type { RadarResponsePayload } from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarResponsePayloadTypes';
import type { LocationExplorerResponse } from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarUnfocusedSearch';
import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { DestinationExplorerState } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/destinationExplorer';

const INITIAL_STATE: DestinationExplorerState = null;

export const extractDestinationExplorer = (
  response: RadarResponsePayload,
): LocationExplorerResponse | null => {
  if (isPlacesResponseError(response)) return null;

  const body = getPlacesResponseBody(response);
  return body && 'destinationExplorer' in body && body.destinationExplorer
    ? body.destinationExplorer
    : null;
};

export default function (
  state: DestinationExplorerState = INITIAL_STATE,
  action: Action,
): DestinationExplorerState {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED: {
      const { payload } = action;
      if (payload.type !== RADAR_CREATE_SESSIONS) {
        return state;
      }
      const destinationExplorer = extractDestinationExplorer(payload.response);
      return destinationExplorer ?? state;
    }
    case MUTATION_REQUEST_SENT: {
      const { payload } = action;
      if (payload.type === RADAR_CREATE_SESSIONS) {
        return INITIAL_STATE;
      }
      return state;
    }

    default:
      return state;
  }
}
